import './RegionesSection.scss';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import logo_educacion from '../../../assets/images/logo_educacion.png';
import icon_play from '../../../assets/images/icon_play_orange.svg';
import { Dialog, DialogContent, Button, Tabs, Tab, Box } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import 'swiper/css/navigation';
import { Navigation, Pagination } from 'swiper/modules';
import pildora_1 from '../../../assets/images/pildora_01.webp';
import pildora_2 from '../../../assets/images/pildora_02.webp';
import pildora_3 from '../../../assets/images/pildora_03.webp';
import pildora_4 from '../../../assets/images/pildora_04.webp';
import pildora_5 from '../../../assets/images/pildora_05.webp';
import pildora_6 from '../../../assets/images/pildora_06.webp';
import pildora_7 from '../../../assets/images/pildora_07.webp';
import pildora_8 from '../../../assets/images/pildora_08.webp';
import pildora_9 from '../../../assets/images/pildora_09.webp';
import pildora_10 from '../../../assets/images/pildora_10.webp';
import pildora_11 from '../../../assets/images/pildora_11.webp';
import pildora_12 from '../../../assets/images/pildora_12.webp';
import pildora_13 from '../../../assets/images/pildora_13.webp';
import pildora_14 from '../../../assets/images/pildora_14.webp';
import pildora_15 from '../../../assets/images/pildora_15.webp';
import pildora_16 from '../../../assets/images/pildora_16.webp';
import pildora_17 from '../../../assets/images/pildora_17.webp';
import pildora_18 from '../../../assets/images/pildora_18.webp';
import pildora_19 from '../../../assets/images/pildora_19.webp';
import pildora_20 from '../../../assets/images/pildora_20.webp';
import pildora_21 from '../../../assets/images/pildora_21.webp';
import pildora_22 from '../../../assets/images/pildora_22.webp';
import pildora_23 from '../../../assets/images/pildora_23.webp';
import pildora_24 from '../../../assets/images/pildora_24.webp';
import pildora_25 from '../../../assets/images/pildora_25.webp';
import pildora_26 from '../../../assets/images/pildora_26.webp';
import pildora_27 from '../../../assets/images/pildora_27.webp';
import memory_1 from '../../../assets/images/1.titulo.webp';
import memory_2 from '../../../assets/images/2.INTRO.webp';
import memory_3 from '../../../assets/images/3.PANEL 1.webp';
import memory_4 from '../../../assets/images/4.PANEL 1 (29am).webp';
import memory_5 from '../../../assets/images/5.conformacion de grupos.webp';
import memory_6 from '../../../assets/images/6.CULTURAS (principios).webp';
import memory_7 from '../../../assets/images/7.POLITICAS (el decalogo).webp';
import memory_8 from '../../../assets/images/8.PRACTICAS(la receta).webp';
import memory_9 from '../../../assets/images/9.experiencias.webp';
import memory_10 from '../../../assets/images/10.GRUPO MUSICAL.webp';
import memory_11 from '../../../assets/images/1. UNAL _panel de experiencias.webp';
import memory_12 from '../../../assets/images/2. UNAL_culturas.webp';
import memory_13 from '../../../assets/images/3. UNAL_Políticas .webp';
import memory_14 from '../../../assets/images/4. UNAL_Practicas.webp';
import classroom from '../../../assets/images/classroom.png';

import img_mag1 from '../../../assets/images/img_mag_amazonas.png';
import img_mag2 from '../../../assets/images/img_mag_andina.png';
import img_mag3 from '../../../assets/images/img_mag_antioquia.png';
import img_mag4 from '../../../assets/images/img_mag_arauca.png';
import img_mag5 from '../../../assets/images/img_mag_caribe.png';
import img_mag6 from '../../../assets/images/img_mag_cesar.png';
import img_mag7 from '../../../assets/images/img_mag_eje_cafetero.png';
import img_mag8 from '../../../assets/images/img_mag_narino.png';
import img_mag9 from '../../../assets/images/img_mag_san_andres.png';
import img_mag10 from '../../../assets/images/img_mag_santander.png';
import img_mag11 from '../../../assets/images/img_mag_tumaco.png';
import img_mag12 from '../../../assets/images/img_mag_valle.png';

import ico_download from '../../../assets/images/ico_download.svg';
import doc_ppt from '../../../assets/documents/ANEXO3_REVISTA_DIGITAL_SECCIONES_V2.pptx';

// Revistas 2025 desde nueva-revista (rutas públicas)
import revistaAntioquiaImg from '../../../assets/documents/2025/nueva-revista/01-antioquia/antioquia.png';
import revistaVaupesImg from '../../../assets/documents/2025/nueva-revista/02-vaupes/vaupes.png';
import revistaChocoImg from '../../../assets/documents/2025/nueva-revista/03-choco/choco.png';
import revistaGuainiaImg from '../../../assets/documents/2025/nueva-revista/04-guainia/guainia.png';
import revistaHuilaImg from '../../../assets/documents/2025/nueva-revista/05-huila/huila.png';
import revistaCaquetaImg from '../../../assets/documents/2025/nueva-revista/06-caqueta/caq.png';
import revistaCordobaImg from '../../../assets/documents/2025/nueva-revista/07-cordoba/cordoba.png';
import revistaNteSantanderImg from '../../../assets/documents/2025/nueva-revista/08-nte-de-santander/ntesantander.png';
import revistaGuajiraImg from '../../../assets/documents/2025/nueva-revista/09-guajira/guajira.png';
import revistaMetaImg from '../../../assets/documents/2025/nueva-revista/10-meta/meta.png';
import revistaCaucaImg from '../../../assets/documents/2025/nueva-revista/11-cauca/cauca.png';
import revistaCasanareImg from '../../../assets/documents/2025/nueva-revista/12-casanare/casanare.png';
import revistaPutumayoImg from '../../../assets/documents/2025/nueva-revista/13-putumayo/putumayo.png';
import revistaGuaviareImg from '../../../assets/documents/2025/nueva-revista/14-guaviare/guaviare.png';
import revistaVichadaImg from '../../../assets/documents/2025/nueva-revista/15-vichada/vichada.png';
import revistaTolimaImg from '../../../assets/documents/2025/nueva-revista/16-tolima/tolima.png';
import revistaSantanderImg from '../../../assets/documents/2025/nueva-revista/17-santander/santander.png';
import revistaValleImg from '../../../assets/documents/2025/nueva-revista/18-valle-del-cauca/valle-cauca.png';
import revistaSucreImg from '../../../assets/documents/2025/nueva-revista/19-sucre/sucre.png';


export const RegionesSection = () => {

  const [open, setOpen] = useState(false);
  const [selectedImages, setSelectedImages] = useState<{ src: string; title: string }[] | null>(null);

  const handleOpen = (index: number) => {
    setSelectedImages(pildoras_bundle[index]);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedImages(null);
  };

  const [open2, setOpen2] = useState(false);
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const [revistasTab, setRevistasTab] = useState(0);
  const [webinarsTab, setWebinarsTab] = useState(0);

  const handleRevistasTabChange = (_: React.SyntheticEvent, newValue: number) => {
    setRevistasTab(newValue);
  };

  const handleWebinarsTabChange = (_: React.SyntheticEvent, newValue: number) => {
    setWebinarsTab(newValue);
  };

  const handleOpen2 = (image: string) => {
    setSelectedImage(image);
    setOpen2(true);
  };

  const handleClose2 = () => {
    setOpen2(false);
    setSelectedImage(null);
  };

  const pildoras_img = [
    pildora_1,
    pildora_4,
    pildora_6,
    pildora_9,
    pildora_11,
    pildora_13,
    pildora_16,
    pildora_18,
    pildora_20,
    pildora_22,
    pildora_25,
  ];

  const pildoras_bundle= [[
    { src: pildora_1, title: 'Píldora 1' },
    { src: pildora_2, title: 'Píldora 2' },
    { src: pildora_3, title: 'Píldora 3' },
  ], [
    { src: pildora_4, title: 'Píldora 4' },
    { src: pildora_5, title: 'Píldora 5' },
  ], [
    { src: pildora_6, title: 'Píldora 6' },
    { src: pildora_7, title: 'Píldora 7' },
    { src: pildora_8, title: 'Píldora 8' },
  ], [
    { src: pildora_9, title: 'Píldora 9' },
    { src: pildora_10, title: 'Píldora 10' },
  ], [
    { src: pildora_11, title: 'Píldora 11' },
    { src: pildora_12, title: 'Píldora 12' },
  ], [
    { src: pildora_13, title: 'Píldora 13' },
    { src: pildora_14, title: 'Píldora 14' },
    { src: pildora_15, title: 'Píldora 15' },
  ], [
    { src: pildora_16, title: 'Píldora 16' },
    { src: pildora_17, title: 'Píldora 17' },
  ], [
    { src: pildora_18, title: 'Píldora 18' },
    { src: pildora_19, title: 'Píldora 19' },
  ], [
    { src: pildora_20, title: 'Píldora 20' },
    { src: pildora_21, title: 'Píldora 21' },
  ], [
    { src: pildora_22, title: 'Píldora 22' },
    { src: pildora_23, title: 'Píldora 23' },
    { src: pildora_24, title: 'Píldora 24' },
  ], [
    { src: pildora_25, title: 'Píldora 25' },
    { src: pildora_26, title: 'Píldora 26' },
    { src: pildora_27, title: 'Píldora 27' },
  ]];

  const relatorias1 = [
    memory_1,
    memory_2,
    memory_3,
    memory_4,
    memory_5,
    memory_6,
    memory_7,
    memory_8,
    memory_9,
    memory_10,
  ];

  const relatorias2 = [
    memory_11,
    memory_12,
    memory_13,
    memory_14,
  ];

  const encuentrosSincronicos2025 = [
    {
      id: 'F7GK_rWQhXY',
      title: 'Encuentro Sincrónico 1: Discapacidad',
      fecha: '8 de octubre de 2025',
      description: 'Muestra la Estrategia de cualificación para la consolidación y apropiación territorial de la Educación Inclusiva para funcionarias y funcionarios de las secretarías de educación de Colombia.',
    },
    {
      id: 'djww8BBlVLQ',
      title: 'Encuentro Sincrónico 2: Capacidades o Talentos Excepcionales',
      fecha: '29 de octubre de 2025',
      description: 'Segundo Encuentro Sincrónico en el marco de la Estrategia de cualificación. Aborda y conversa acerca de todos los aspectos clave de estudiantes con capacidades o talentos excepcionales.',
    },
    {
      id: 'YJHh2T7mtMA',
      title: 'Encuentro Sincrónico 3: Trastorno del Aprendizaje y TDA/TDAH',
      fecha: '18 de noviembre de 2025',
      description: 'Tercer Encuentro Sincrónico. Aborda los aspectos clave de estudiantes con trastorno específico del aprendizaje o déficit de atención con/sin hiperactividad.',
    },
    {
      id: 'E01JCYLtSEQ',
      title: 'Encuentro Sincrónico 4',
      fecha: '4 de diciembre de 2025',
      description: 'Cuarto Encuentro Sincrónico en el marco de la Estrategia de cualificación para la consolidación y apropiación territorial de la Educación Inclusiva para funcionarias y funcionarios de las secretarías de educación de Colombia.',
    },
  ];

  const revistasDigitales2025 = [
    { nombre: 'Antioquia - Apartadó', src: revistaAntioquiaImg, pdf: '/Assets/documents/2025/nueva-revista/01-antioquia/MEN_UNAL_REVISTA_APARTADO.pdf' },
    { nombre: 'Vaupés - Mitú', src: revistaVaupesImg, pdf: '/Assets/documents/2025/nueva-revista/02-vaupes/MEN_UNAL_REVISTA_MITU.pdf' },
    { nombre: 'Chocó - Quibdó', src: revistaChocoImg, pdf: '/Assets/documents/2025/nueva-revista/03-choco/MEN_UNAL_REVISTA_QUIBDÓ.pdf' },
    { nombre: 'Guainía - Puerto Inírida', src: revistaGuainiaImg, pdf: '/Assets/documents/2025/nueva-revista/04-guainia/MEN_UNAL_REVISTA_PTO INIRIDA.pdf' },
    { nombre: 'Huila - Pitalito', src: revistaHuilaImg, pdf: '/Assets/documents/2025/nueva-revista/05-huila/MEN_UNAL_REVISTA_PITALITO.pdf' },
    { nombre: 'Caquetá - Florencia', src: revistaCaquetaImg, pdf: '/Assets/documents/2025/nueva-revista/06-caqueta/MEN_UNAL_REVISTA_FLORENCIA.pdf' },
    { nombre: 'Córdoba - Montería', src: revistaCordobaImg, pdf: '/Assets/documents/2025/nueva-revista/07-cordoba/MEN_UNAL_REVISTA_MONTERIA.pdf' },
    { nombre: 'Norte de Santander - Cúcuta', src: revistaNteSantanderImg, pdf: '/Assets/documents/2025/nueva-revista/08-nte-de-santander/MEN_UNAL_REVISTA_CUCTA.pdf' },
    { nombre: 'La Guajira - Riohacha', src: revistaGuajiraImg, pdf: '/Assets/documents/2025/nueva-revista/09-guajira/MEN_UNAL_REVISTA_RIOACHA.pdf' },
    { nombre: 'Meta - Villavicencio', src: revistaMetaImg, pdf: '/Assets/documents/2025/nueva-revista/10-meta/MEN_UNAL_REVISTA_VILLAVIVENCIO.pdf' },
    { nombre: 'Cauca - Popayán', src: revistaCaucaImg, pdf: '/Assets/documents/2025/nueva-revista/11-cauca/MEN_UNAL_REVISTA_POPAYAN.pdf' },
    { nombre: 'Casanare - Yopal', src: revistaCasanareImg, pdf: '/Assets/documents/2025/nueva-revista/12-casanare/MEN_UNAL_REVISTA_YOPAL.pdf' },
    { nombre: 'Putumayo - Mocoa', src: revistaPutumayoImg, pdf: '/Assets/documents/2025/nueva-revista/13-putumayo/MEN_UNAL_REVISTA_MOCOA.pdf' },
    { nombre: 'Guaviare', src: revistaGuaviareImg, pdf: '/Assets/documents/2025/nueva-revista/14-guaviare/MEN_UNAL_REVISTA_GUAVIARE.pdf' },
    { nombre: 'Vichada - Puerto Carreño', src: revistaVichadaImg, pdf: '/Assets/documents/2025/nueva-revista/15-vichada/MEN_UNAL_REVISTA_PTO CARREÑO.pdf' },
    { nombre: 'Tolima - Ibagué', src: revistaTolimaImg, pdf: '/Assets/documents/2025/nueva-revista/16-tolima/MEN_UNAL_REVISTA_IBAGUE.pdf' },
    { nombre: 'Santander - Barrancabermeja', src: revistaSantanderImg, pdf: '/Assets/documents/2025/nueva-revista/17-santander/MEN_UNAL_REVISTA_BARRANCABEMEJA.pdf' },
    { nombre: 'Valle del Cauca - Cartago', src: revistaValleImg, pdf: '/Assets/documents/2025/nueva-revista/18-valle-del-cauca/MEN_UNAL_REVISTA_CARTAGO.pdf' },
    { nombre: 'Sucre - Sincelejo', src: revistaSucreImg, pdf: '/Assets/documents/2025/nueva-revista/19-sucre/MEN_UNAL_REVISTA_SINCELEJO.pdf' },
  ];

  const magazineRegItems = [
    { src: img_mag1, pdf: 'https://drive.google.com/file/d/1-bsXfFq-4kz4ZbKLQ7J6VfLMWTggyPJm/view?usp=drive_link' },
    { src: img_mag2, pdf: 'https://drive.google.com/file/d/1OhDi0Y6dCfVdnMVdyJbtSZ4dbSC8BcCf/view?usp=drive_link' },
    { src: img_mag3, pdf: 'https://drive.google.com/file/d/1rcU3YYDKFqdPqD2UROkGE_DXIzTV3QA_/view?usp=drive_link' },
    { src: img_mag4, pdf: 'https://drive.google.com/file/d/1rcU3YYDKFqdPqD2UROkGE_DXIzTV3QA_/view?usp=drive_link' },
    { src: img_mag5, pdf: 'https://drive.google.com/file/d/1rcU3YYDKFqdPqD2UROkGE_DXIzTV3QA_/view?usp=drive_link' },
    { src: img_mag6, pdf: 'https://drive.google.com/file/d/1rcU3YYDKFqdPqD2UROkGE_DXIzTV3QA_/view?usp=drive_link' },
    { src: img_mag7, pdf: 'https://drive.google.com/file/d/1rcU3YYDKFqdPqD2UROkGE_DXIzTV3QA_/view?usp=drive_link' },
    { src: img_mag8, pdf: 'https://drive.google.com/file/d/1rcU3YYDKFqdPqD2UROkGE_DXIzTV3QA_/view?usp=drive_link' },
    { src: img_mag9, pdf: 'https://drive.google.com/file/d/1rcU3YYDKFqdPqD2UROkGE_DXIzTV3QA_/view?usp=drive_link' },
    { src: img_mag10, pdf: 'https://drive.google.com/file/d/1rcU3YYDKFqdPqD2UROkGE_DXIzTV3QA_/view?usp=drive_link' },
    { src: img_mag11, pdf: 'https://drive.google.com/file/d/1rcU3YYDKFqdPqD2UROkGE_DXIzTV3QA_/view?usp=drive_link' },
    { src: img_mag12, pdf: 'https://drive.google.com/file/d/1rcU3YYDKFqdPqD2UROkGE_DXIzTV3QA_/view?usp=drive_link' },
  ];

  return (
    <>

      {/* Banner section */}
      <Grid container className='Regiones-banner-container'>
        <Grid item xs={12} lg={6} className='logos-left'>
          <img className="logo-1" alt="Logo Ministerio de educación" src={logo_educacion} />
        </Grid>
        <Grid item xs={12} lg={6} className='content-right'>
          <h1 className='title'><b>El cambio en las regiones</b></h1>
        </Grid>
      </Grid>

      {/* Description section */}
      <Grid container className='Regiones-description-container backContraste'>
        <Grid item xs={12} className='text-container'>
          <Grid xs={11}>
            <Typography className='title'>
              <b>Tejiendo redes desde las regiones:</b> Inclusión y equidad en la educación para la construcción de país
            </Typography>
          </Grid>
        </Grid>
        <Grid item xs={12} className='text-container'>
          <Grid item xs={11} lg={10}>
            <Typography className='text-info'>
              Este espacio tiene como propósito principal <b>conectar a líderes y referentes en inclusión y equidad en la educación de todo el país</b>, promoviendo el <b>intercambio de conocimientos y prácticas significativas</b> que reflejan la diversidad regional. A través de este intercambio, se promueven estrategias transformadoras en la atención de <b>niñas, niños, adolescentes, jóvenes y adultos</b> con discapacidad, trastornos del aprendizaje y/o del comportamiento, capacidades o talentos excepcionales, así como aquellos que requieren apoyo académico especial debido a condiciones de salud.
            </Typography>
          </Grid>
        </Grid>
      </Grid>

      {/* Encuentros Sincrónicos 2025 - Carrusel (contenido más reciente primero) */}
      <Grid container className='Regiones-encuentros-sincronicos-container backContraste'>
        <Grid container justifyContent={'center'}>
          <Grid xs={11}>
            <hr className='separator'/>
          </Grid>
        </Grid>
        <Grid item xs={12} className='text-container'>
          <Grid xs={11} lg={10}>
            <Typography className='title'>
              Encuentros Sincrónicos 2025: Estrategia de cualificación territorial
            </Typography>
          </Grid>
        </Grid>
        <Grid item xs={12} className='text-container'>
          <Grid item xs={11} lg={10}>
            <Typography className='text-info'>
              Grabaciones de los Encuentros Sincrónicos en el marco de la Estrategia de cualificación para la consolidación y apropiación territorial de la Educación Inclusiva para funcionarias y funcionarios de las secretarías de educación de Colombia. Navega entre los videos con las flechas o los puntos de indicador.
            </Typography>
          </Grid>
        </Grid>
        <Grid container item xs={12} justifyContent='center' className='encuentros-carousel-wrapper'>
          <Grid item xs={11} lg={10}>
            <Swiper
              modules={[Navigation, Pagination]}
              spaceBetween={30}
              slidesPerView={1}
              navigation
              pagination={{ clickable: true, dynamicBullets: true }}
              className='encuentros-sincronicos-carousel'
              aria-label="Carrusel de Encuentros Sincrónicos 2025"
            >
              {encuentrosSincronicos2025.map((video, index) => (
                <SwiperSlide key={index} className='encuentro-video-slide'>
                  <div className='encuentro-slide-content'>
                    <Typography className='encuentro-slide-title'>{video.title}</Typography>
                    <Typography className='encuentro-slide-fecha'>{video.fecha}</Typography>
                    <div className='encuentro-iframe-wrapper'>
                      <iframe
                        src={`https://www.youtube.com/embed/${video.id}`}
                        allowFullScreen
                        allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                        title={video.title}
                        className='encuentro-youtube-iframe'
                      />
                    </div>
                    <div className='encuentro-description'>
                      <img src={icon_play} alt="" className='encuentro-icon-play' aria-hidden="true" />
                      <Typography className='encuentro-slide-description'>{video.description}</Typography>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </Grid>
        </Grid>
      </Grid>

      {/* Pildoras section */}
      <Grid container className='Regiones-pildoras-container backContraste'>
        <Grid item xs={12} className='text-container'>
          <Grid xs={11}>
            <Typography className='title'>
              Píldoras de responsabilidades
            </Typography>
          </Grid>
        </Grid>
        <Grid item xs={12} className='text-container'>
          <Grid item xs={11} lg={10}>
            <Typography className='text-info'>
              En esta sección se presentan píldoras informativas sobre las responsabilidades compartidas por los funcionarios de las Secretarías de Educación. El propósito es proporcionar información, inspirar y fomentar la conexión entre los actores de las diferentes áreas, con el fin de que, desde sus roles y mediante acciones articuladas, contribuyan a promover transformaciones orientadas a garantizar la inclusión y la equidad en la educación.
            </Typography>
          </Grid>
        </Grid>
        <Grid container spacing={2} className='pildoras-container'>
          {pildoras_img.map((image, index) => (
            <Grid item container xs={12} lg={3} justifyContent={'center'} key={index}>
              <img src={image} alt={`Píldora informativa ${index + 1}: responsabilidades compartidas`} className='pildora-img'
                onClick={() => handleOpen(index)}
                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleOpen(index); } }}
                role="button"
                tabIndex={0}
                style={{ cursor: 'pointer' }}
                aria-label={`Abrir píldora informativa ${index + 1}`} />
            </Grid>
          ))}
          
          <Dialog open={open} onClose={handleClose} maxWidth='xl'>
            <DialogContent className='pildoras-modal' style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
              {selectedImages && selectedImages.map((image, idx) => (
                <div key={idx} style={{ textAlign: 'center' }}>
                  <Typography className='subtitle'>
                    {image.title}
                  </Typography>
                  <img
                    src={image.src}
                    alt={`Píldora ${idx + 1}`}
                    style={{
                      width: '400px',
                      height: 'auto',
                      display: 'block',
                    }}
                  />
                </div>
              ))}
            </DialogContent>
          </Dialog>
        </Grid>
      </Grid>
      <div className='button-container backContraste'>
        <Button 
          variant="contained" 
          color="primary" 
          onClick={() => window.open("https://drive.google.com/file/d/1Zvfz91nezZrXOH8fp-3GP2FFaliZ2Iuy/view?usp=drive_link", '_blank')}
          aria-label="Descargar todas las píldoras de responsabilidades en PDF (enlace externo)" >
          Descargar todas las piezas en PDF
        </Button>
      </div>

      {/* memories section */}
      <Grid container className='Regiones-memories-container backContraste'>
        <Grid container justifyContent={'center'}>
          <Grid xs={11}>
            <hr className='separator'/>
          </Grid>
        </Grid>
        <Grid item xs={12} className='text-container'>
          <Grid xs={11}>
            <Typography className='title'>
              Memorias Segundo Encuentro Nacional de Líderes y Referentes en inclusión y equidad en la educación
            </Typography>
          </Grid>
        </Grid>
        <Grid item xs={12} className='text-container'>
          <Grid item xs={11} lg={10}>
            <Typography className='text-info'>
              Los espacios de diálogo de este encuentro facilitaron el intercambio de ideas y perspectivas desde las dimensiones de culturas, políticas y prácticas. Este ejercicio colectivo quedó reflejado en relatorías gráficas que se presentan en esta sección, con el propósito de visualizar y comprender lo sucedido, así como de seguir impulsando el diálogo y la reflexión sobre estos temas fundamentales.
            </Typography>
          </Grid>
        </Grid>
        <Swiper
          modules={[Navigation]}
          navigation
          spaceBetween={10}
          slidesPerView={1}
          breakpoints={{
            1024: { slidesPerView: 3 },
            600: { slidesPerView: 1 },
          }}
          pagination={{ clickable: true }}
          className='memories-carousel backContraste'
          aria-label="Carrusel de relatorías gráficas del Segundo Encuentro Nacional"
        >
          {relatorias1.map((image, index) => (
            <SwiperSlide key={index} className='memories-carousel-slide'>
              <img
                src={image}
                alt={`Relatoría gráfica ${index + 1} del Segundo Encuentro Nacional`}
                className='memory-img'
                onClick={() => handleOpen2(image)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleOpen2(image); } }}
                aria-label={`Ver relatoría ${index + 1} en tamaño completo`}
              />
            </SwiperSlide>
          ))}
        </Swiper>
        
        <Swiper
          modules={[Navigation]}
          navigation
          spaceBetween={10}
          slidesPerView={1}
          breakpoints={{
            1024: { slidesPerView: 2 },
            600: { slidesPerView: 1 },
          }}
          pagination={{ clickable: true }}
          className='memories-carousel backContraste'
          aria-label="Carrusel de relatorías UNAL"
        >
          {relatorias2.map((image, index) => (
            <SwiperSlide key={index} className='memories-carousel-slide'>
              <img
                src={image}
                alt={`Relatoría UNAL ${index + 1}`}
                className='memory-img'
                onClick={() => handleOpen2(image)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleOpen2(image); } }}
                aria-label={`Ver relatoría UNAL ${index + 1} en tamaño completo`}
              />
            </SwiperSlide>
          ))}
        </Swiper>
        <Dialog open={open2} onClose={handleClose2} maxWidth='lg'>
          <DialogContent style={{ padding: 0 }}>
            {selectedImage && (
              <img
                src={selectedImage}
                alt='Imagen ampliada'
                style={{
                  width: '100%',
                  height: 'auto',
                  display: 'block',
                }}
              />
            )}
          </DialogContent>
        </Dialog>
      </Grid>
      <div className='button-container backContraste'>
          <Button 
            variant="contained" 
            color="primary" 
            onClick={() => window.open("https://drive.google.com/file/d/16RZK1xW8Jt1cwzPi5bYyADULKja3R9E5/view?usp=sharing", '_blank')}
            aria-label="Descargar memorias del encuentro en PDF (enlace externo)"
          >
            Descargar todas las piezas en PDF
          </Button>
        </div>

      {/* Webinars - Tabs unificados */}
      <Grid container className='Regiones-webinars-container backContraste'>
        <Grid container justifyContent={'center'}>
          <Grid xs={11}>
            <hr className='separator'/>
          </Grid>
        </Grid>
        <Grid item xs={12} className='text-container webinars-header'>
          <Grid xs={12} container justifyContent='center'>
            <Typography className='title webinars-title'>
              Webinars
            </Typography>
          </Grid>
        </Grid>

        <Grid item xs={12} className='webinars-tabs-container'>
          <Tabs
            value={webinarsTab}
            onChange={handleWebinarsTabChange}
            variant="fullWidth"
            centered
            className="webinars-tabs"
            TabIndicatorProps={{ style: { backgroundColor: '#d9488c', height: 4 } }}
          >
            <Tab label="Webinars 2025" id="webinars-tab-0" aria-controls="webinars-panel-0" />
            <Tab label="Webinars 6 dic 2024" id="webinars-tab-1" aria-controls="webinars-panel-1" />
          </Tabs>

          <Box role="tabpanel" hidden={webinarsTab !== 0} id="webinars-panel-0" aria-labelledby="webinars-tab-0" className="webinars-tab-panel">
            {webinarsTab === 0 && (
              <>
                <Grid item xs={12} className='text-container webinars-tab-intro'>
                  <Grid item xs={12} container justifyContent='center'>
                    <Typography className='text-info webinars-intro'>
                      Serie de webinars nacionales sobre educación inclusiva. Navega entre los videos o accede a la playlist completa en YouTube.
                    </Typography>
                  </Grid>
                </Grid>
                <Grid container item xs={12} justifyContent='center' className='webinars-carousel-wrapper'>
                  <Grid item xs={11} lg={10}>
                    <Swiper
              modules={[Navigation, Pagination]}
              spaceBetween={30}
              slidesPerView={1}
              navigation
              pagination={{ clickable: true, dynamicBullets: true }}
              observer
              observeParents
              className='webinars-carousel'
              aria-label="Carrusel de webinars 2025 sobre educación inclusiva"
            >
              {[
                { num: 1, id: 'RjO-5k8bnoA', title: 'Primer Webinar Nacional Educación Sin Barreras' },
                { num: 2, id: 'T5YoT9ycj0c', title: 'Segundo Webinar Nacional Educación Sin Barreras' },
                { num: 4, id: 'p9YHOUNd8Vc', title: 'Cuarto Webinar Nacional Educación Sin Barreras' },
                { num: 5, id: 'EbQ7vE_giyA', title: 'Quinto Webinar Nacional Educación Sin Barreras' },
                { num: 6, id: 'gCa7C-hgGQ4', title: 'Sexto Webinar Nacional Educación Sin Barreras' },
                { num: 7, id: '7Ba6WimJS1g', title: 'Séptimo Webinar Nacional Educación Sin Barreras' },
                { num: 8, id: 'TSDdx8u-y_w', title: 'Octavo Webinar Nacional Educación Sin Barreras' },
                { num: 9, id: 'bzMUX4L7KRU', title: 'Noveno Webinar Nacional Educación Sin Barreras' },
              ].map((webinar) => (
                <SwiperSlide key={webinar.num} className='webinar-video-slide'>
                  <div className='webinar-slide-content'>
                    <Typography className='webinar-slide-title'>{webinar.title}</Typography>
                    <div className='webinar-iframe-wrapper'>
                      <iframe
                        src={`https://www.youtube.com/embed/${webinar.id}`}
                        allowFullScreen
                        allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                        title={webinar.title}
                        className='webinar-youtube-iframe'
                      />
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </Grid>
        </Grid>
                <Grid item xs={12} className='text-container webinars-playlist-wrapper'>
                  <Button
                    variant="contained"
                    size="large"
                    onClick={() => window.open('https://www.youtube.com/watch?v=mNKWbdFHQ6g&list=PL1VAUqRo7gEItuaYXIXNqaRSlx-Ekxrge', '_blank')}
                    className="playlist-button"
                    sx={{ backgroundColor: '#d9488c', '&:hover': { backgroundColor: '#c23d7a' } }}
                    aria-label="Abrir playlist completa de webinars en YouTube (enlace externo)"
                  >
                    Ver playlist completa en YouTube
                  </Button>
                </Grid>
              </>
            )}
          </Box>

          <Box role="tabpanel" hidden={webinarsTab !== 1} id="webinars-panel-1" aria-labelledby="webinars-tab-1" className="webinars-tab-panel">
            {webinarsTab === 1 && (
              <>
                <Grid item xs={12} className='text-container'>
                  <Grid item xs={12} container justifyContent='center'>
                    <Typography className='text-info'>
                      Reflexiones para promover una educación inclusiva con énfasis en estudiantes que requieren apoyos y ajustes razonables.
                    </Typography>
                  </Grid>
                </Grid>
                <Grid container item xs={12} justifyContent='center' className='webinars-carousel-wrapper'>
                  <Grid item xs={11} lg={10}>
                    <Swiper
                      modules={[Navigation, Pagination]}
                      spaceBetween={30}
                      slidesPerView={1}
                      navigation
                      pagination={{ clickable: true, dynamicBullets: true }}
                      observer
                      observeParents
                      className='webinars-carousel'
                      aria-label="Carrusel de webinars 6 diciembre 2024"
                    >
                      {[
                        { title: 'Webinar 1: Aulas Hospitalarias', description: 'Explora cómo garantizar una educación inclusiva para estudiantes que requieren apoyos académicos especiales debido a condiciones de salud. Camilo Salgado, experto en el tema, compartirá su conocimiento, experiencias y estrategias clave.' },
                        { title: 'Webinar 2: Trastornos específicos del aprendizaje y/o del comportamiento', description: 'Yeison Guerrero, experto en el campo, guiará una conversación sobre cómo construir una educación verdaderamente inclusiva. Explora estrategias para implementar apoyos y ajustes razonables.' },
                        { title: 'Webinar 3: Capacidades o talentos excepcionales', description: 'Diana Álvarez, líder del equipo de inclusión y equidad en la educación del MEN, guiará un diálogo inspirador sobre cómo garantizar el derecho a la educación para estudiantes con capacidades o talentos excepcionales.' },
                      ].map((webinar, idx) => (
                        <SwiperSlide key={idx} className='webinar-video-slide'>
                          <div className='webinar-slide-content'>
                            <Typography className='webinar-slide-title'>{webinar.title}</Typography>
                            <div className='webinar-placeholder'>
                              <Typography variant="body2" color="textSecondary">
                                Video no disponible
                              </Typography>
                            </div>
                            <div className='video-item' style={{ display: 'flex', alignItems: 'flex-start', gap: '1rem', padding: '1rem 0' }}>
                              <img src={icon_play} alt="" className='info-img' style={{ width: '2.5rem', flexShrink: 0 }} aria-hidden="true" />
                              <Typography className='text'>{webinar.description}</Typography>
                            </div>
                          </div>
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  </Grid>
                </Grid>
              </>
            )}
          </Box>
        </Grid>
      </Grid>

      {/* Revistas - Tabs para organización */}
      <Grid container className='Regiones-reg-magazin-container backContraste'>
        <Grid container justifyContent={'center'}>
          <Grid xs={11}>
            <hr className='separator'/>
          </Grid>
        </Grid>
        <Grid item xs={12} container className='text-container'>
          <Grid xs={11} lg={8}>
            <Typography className='title'>
              Espacio virtual de interacción y colaboración entre las Secretarías de Educación
            </Typography>
          </Grid>
        </Grid>
        <Grid item xs={12} className='text-container'>
          <Grid item xs={11} lg={10}>
            <Typography className='text-info'>
              Los invitamos a explorar las revistas que reúnen los avances y aprendizajes del Encuentro Regional realizado en el marco del Convenio. Selecciona la pestaña según el recurso que desees consultar.
            </Typography>
          </Grid>
        </Grid>

        <Grid item xs={12} className='revistas-tabs-container'>
          <Tabs
            value={revistasTab}
            onChange={handleRevistasTabChange}
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            className="revistas-tabs"
            TabIndicatorProps={{ style: { backgroundColor: '#d9488c' } }}
          >
            <Tab label="Revistas 2025" id="revistas-tab-0" aria-controls="revistas-panel-0" />
            <Tab label="Revistas regionales" id="revistas-tab-1" aria-controls="revistas-panel-1" />
            <Tab label="Plantilla ETC" id="revistas-tab-2" aria-controls="revistas-panel-2" />
          </Tabs>

          <Box role="tabpanel" hidden={revistasTab !== 0} id="revistas-panel-0" aria-labelledby="revistas-tab-0" className="revistas-tab-panel">
            {revistasTab === 0 && (
              <>
                <Box className="tab-info-box">
                  <InfoOutlinedIcon className="tab-info-icon" aria-hidden="true" />
                  <Typography className="tab-info-text">
                    12 revistas digitales por territorio. Haz clic para abrir el PDF en una nueva pestaña.
                  </Typography>
                </Box>
                <Grid container item xs={12} className='revistas-gallery'>
                  {revistasDigitales2025.map((item, index) => (
                    <Grid item xs={12} sm={6} md={4} key={index} className='gallery-item'>
                      <a href={item.pdf} target="_blank" rel="noopener noreferrer" className="revista-link" aria-label={`Abrir PDF: Revista digital ${item.nombre}`}>
                        <div className='image-container'>
                          <img src={item.src} alt={`Portada de la revista digital ${item.nombre}`} className='gallery-image' loading="lazy" />
                          <div className='overlay'>
                            <img src={ico_download} alt="" className='icon' aria-hidden="true" />
                            <span className='overlay-text'>Revista {item.nombre}</span>
                          </div>
                        </div>
                      </a>
                    </Grid>
                  ))}
                </Grid>
              </>
            )}
          </Box>

          <Box role="tabpanel" hidden={revistasTab !== 1} id="revistas-panel-1" aria-labelledby="revistas-tab-1" className="revistas-tab-panel">
            {revistasTab === 1 && (
              <>
                <Box className="tab-info-box">
                  <InfoOutlinedIcon className="tab-info-icon" aria-hidden="true" />
                  <Typography className="tab-info-text">
                    Revistas regionales por territorio. Haz clic para abrir el PDF en una nueva pestaña.
                  </Typography>
                </Box>
                <Grid container item xs={12} className='revistas-gallery'>
                  {magazineRegItems.map((item, index) => (
                    <Grid item xs={12} sm={6} md={4} key={index} className='gallery-item'>
                      <div className='image-container' onClick={() => window.open(item.pdf, '_blank')} role="button" tabIndex={0} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); window.open(item.pdf, '_blank'); } }} aria-label={`Abrir revista regional ${index + 1} en PDF`}>
                        <img src={item.src} alt={`Portada revista regional ${index + 1}`} className='gallery-image' loading="lazy" />
                        <div className='overlay'>
                          <img src={ico_download} alt="" className='icon' aria-hidden="true" />
                          <span className='overlay-text'>Ver PDF</span>
                        </div>
                      </div>
                    </Grid>
                  ))}
                </Grid>
              </>
            )}
          </Box>

          <Box role="tabpanel" hidden={revistasTab !== 2} id="revistas-panel-2" aria-labelledby="revistas-tab-2" className="revistas-tab-panel">
            {revistasTab === 2 && (
              <Box className="plantilla-tab-content">
                <Typography className='title'>Revista digital para cada ETC</Typography>
                <Typography className='text-info' sx={{ maxWidth: 800, mx: 'auto', mt: 2 }}>
                  Plantilla PowerPoint para que cada Secretaría de Educación presente sus avances, logros y desafíos. Un insumo clave para el Tercer Encuentro Nacional de Líderes y Referentes en Inclusión y Equidad en la Educación.
                </Typography>
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  onClick={() => window.open(doc_ppt, '_blank')}
                  sx={{ mt: 3 }}
                  aria-label="Descargar plantilla PowerPoint para ETC"
                >
                  Descargar Plantilla PowerPoint
                </Button>
              </Box>
            )}
          </Box>
        </Grid>
      </Grid>

      {/* Espacio virtual de interacción - Sección oculta temporalmente */}
      {/* <Grid container className='Regiones-classroom-container backContraste'>
        <Grid container justifyContent={'center'}>
          <Grid xs={11}>
            <hr className='separator'/>
          </Grid>
        </Grid>
        <Grid item xs={12} className='text-container'>
          <Grid xs={11} lg={8}>
            <Typography className='title'>
              Espacio virtual de interacción y colaboración entre las Secretarías de Educación
            </Typography>
          </Grid>
        </Grid>
        <Grid container item xs={12} justifyContent={'center'}>
          <Grid xs={11} lg={4} className='img-container'>
            <img src={classroom} alt='Icono de classroom' className='info-img' />
          </Grid>
          <Grid item xs={12} lg={5} className='text-container'>
          <Grid xs={11}>
            <Typography className='text-info'>
              En este espacio se presentan <b>10 retos clave que enfrentan las Secretarías de Educación</b>, acompañados de recomendaciones prácticas para facilitar su resolución. Además, se ofrece un <b>entorno interactivo</b> que permite <b>compartir ideas y sugerencias</b>, así como <b>intercambiar datos de contacto entre las Secretarías</b>, fomentando el acompañamiento mutuo y la articulación para abordar estos desafíos de manera conjunta.
            </Typography>
            <div className='button-container backContraste'>
                <Button 
                    type="button"
                    variant="contained" 
                    fullWidth 
                    className='submit-button'
                    onClick={() => window.open("https://classroom.google.com/c/NzQyOTEyNzUwNzk2?cjc=dtevn5f", '_blank')}
                >
                    <Typography className='btn-txt'>
                      Classroom
                    </Typography>
                </Button>
            </div>
          </Grid>
        </Grid>
        </Grid>
      </Grid> */}

    </>
  );
};
